/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import get from 'lodash/get';
import Icon from '../commons/Icon';
import ChallengeOverviewSecondaryInfo from './ChallengeOverviewSecondaryInfo';
import ChallengeTimeStatusInfo from './ChallengeTimeStatusInfo';

type Props = {
  hideSecondaryInfo?: boolean,
  title: string,
  isTargetChallenge: boolean,
};

const defaultProps = {
  hideSecondaryInfo: false,
};

const Wrapper = glamorous.div(({ theme }) => ({
  color: theme.color.white,
  ...padding(theme.spacing.small),
  textTransform: 'uppercase',
  [theme.mediaQuery.desktopAndUp]: {
    ...padding(theme.spacing.medium),
  },
  [theme.mediaQuery.desktopLargeOnly]: {
    display: 'flex',
  },
}));

const Primary = glamorous.div({
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
});

const Title = glamorous.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.bold,
  [theme.mediaQuery.desktopLargeOnly]: {
    justifyContent: 'flex-start',
  },
}));

const SportsIcon = glamorous(Icon)(({ theme }) => ({
  color: get(theme.color, 'sportsIcon', theme.color.primary),
  fontSize: theme.fontSize.xlarge,
  marginRight: theme.spacing.tiny,
}));

function ChallengeOverview({ hideSecondaryInfo, isTargetChallenge, title }: Props) {
  return (
    <Wrapper>
      <Primary>
        <Title>
          {isTargetChallenge && (
            <SportsIcon type="icon-target" />
          )}{title}
        </Title>
        <ChallengeTimeStatusInfo />
      </Primary>
      {!hideSecondaryInfo && <ChallengeOverviewSecondaryInfo />}
    </Wrapper>
  );
}

ChallengeOverview.defaultProps = defaultProps;

export default ChallengeOverview;
